// Firebase app initialization.
// Fill in real project values in a local .env file (see .env.example) —
// never commit real keys to version control. Create React App only
// exposes env vars prefixed with REACT_APP_ to the browser bundle.
import { initializeApp, getApps, getApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';
import { getAnalytics, isSupported } from 'firebase/analytics';

const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID,
};

// Avoid re-initializing during hot reload in dev.
export const app = getApps().length ? getApp() : initializeApp(firebaseConfig);

export const db = getFirestore(app);

// Analytics only works in a browser that supports it, so guard the call.
export const analyticsReady = (async () => {
  if (typeof window === 'undefined') return null;
  const supported = await isSupported().catch(() => false);
  return supported ? getAnalytics(app) : null;
})();
